import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 9,
    type: CHECKLIST_ITEM_TYPE.PHONE_CALLED,
    manifestKey: 'PHONE_CALLED',

    try_it: {
        button_label: 'Log Phone Call',
        // PHONE_CALLED uses OpenFollowUpCell (with phone actionIcon) in the switch
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'OpenFollowUpCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { duration_seconds: 120 },
        },
    },
    pre_flight_diff: [
        'Phone call icon cell — triggers follow-up flow with phone icon',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'Note: functionally overlaps with OPEN_FOLLOW_UP — both log phone contact separately',
        'No lead status change',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
